import { TrackingEventName, track } from '@heidi/analytics/events';
import { type ButtonAction, ScreenName } from '@heidi/analytics/vocabulary';
import type { Period } from '@heidi/commerce/contracts';
import type { BillingSeatType, SubscriptionTier } from '@heidi/schema/ml-scribe';

export type PricingPlansModalCtaTrackArgs = {
  action: ButtonAction;
  label: string;
  currentPlan?: SubscriptionTier;
  currentSeatType?: BillingSeatType | null;
  targetTier?: SubscriptionTier;
  /** Clinician and Clinician Max share `target_plan`; this is what tells them apart. */
  targetSeatType?: BillingSeatType;
  period?: Period;
  isInReverseTrial: boolean;
  isFakeClinicianTrial: boolean;
};

/**
 * The one `button_clicked` shape for every CTA in the pricing plans modal.
 * Snowplow + Datadog only — `amplitude: false` is the policy for new sites.
 */
export function trackPricingPlansModalCta({
  action,
  label,
  currentPlan,
  currentSeatType,
  targetTier,
  targetSeatType,
  period,
  isInReverseTrial,
  isFakeClinicianTrial,
}: PricingPlansModalCtaTrackArgs) {
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.ButtonClicked,
    props: {
      screen_name: ScreenName.PricingPlansModal,
      action,
      label,
      ...(currentPlan !== undefined && { current_plan: currentPlan }),
      ...(currentSeatType != null && { current_seat_type: currentSeatType }),
      ...(targetTier !== undefined && { target_plan: targetTier }),
      ...(targetSeatType !== undefined && { target_seat_type: targetSeatType }),
      ...(period !== undefined && { period: String(period) }),
      is_reverse_trial: isInReverseTrial,
      is_fake_trial: isFakeClinicianTrial,
    },
  });
}
